import 'zone.js';
import 'reflect-metadata';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import 'bootstrap';

const rootElemTagName = 'app'; // Update this if you change your root component selector

if (module['hot']) {
    module['hot'].accept();
    module['hot'].dispose(() => {
        const oldRootElem = document.querySelector(rootElemTagName);
        const newRootElem = document.createElement(rootElemTagName);
        oldRootElem.parentNode.insertBefore(newRootElem, oldRootElem);
        platform.destroy();
    });
} else {
    enableProdMode();
}

const platform = platformBrowserDynamic();
const bootApplication = () => {
    console.log('Bootstrapping application...');
    platform.bootstrapModule(AppModule)
        .then(success => console.log(`Bootstrap success`))
        .catch(err => console.error('Bootstrap error', err));
};

if (document.readyState === 'complete') {
    bootApplication();
} else {
    document.addEventListener('DOMContentLoaded', bootApplication);
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/boot-client.ts